import AddApplicationHeader from "./components/AddApplicationHeader";
import ChoiceDetailsCard from "./components/ChoiceDetailsCard";
import CourseInfoCard from "./components/CourseInfoCard";
import ChildPrefrenceCard from "./components/ChildPrefrenceCard";
import RequiredDocumentsCard from "./components/RequiredDocumentsCard";

export default function CreateApplication({
  title = "Add Application",
  description = "Create a new parallel option for this lead",
}: any) {
  return (
    <>
      <AddApplicationHeader title={title} description={description} />
      <div className="p-5 flex flex-col gap-4">
        <ChoiceDetailsCard />
        <CourseInfoCard />
        <ChildPrefrenceCard />
        <RequiredDocumentsCard />
      </div>
    </>
  );
}
